import ReactController from '~/controllers/react_controller'
import AWSRDSDashboardCharts from '~/dashboard/aws_rds_dashboard_charts'

export default class AWSRDSDashboardChartsController extends ReactController {
  static values = {
    organizationId: String,
  }

  createComponent() {
    return <AWSRDSDashboardCharts organizationId={this.organizationIdValue} />
  }
}
